<div class="modal-header">
  <h5 *ngIf="selectedSede && selectedSede != null && selectedSede.id > 0"  class="modal-title">Modifica Sede</h5>
  <h5 *ngIf="selectedSede && selectedSede != null && selectedSede.id == undefined" class="modal-title" >Aggiungi Sede</h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="selectedSede && selectedSede != null" class="modal-body">
  <div class="col-12 ">
    <div *ngIf="tipologieSedi" class="">
      <label class="control-label col-form-label">Tipologia sede</label>
      <ng-multiselect-dropdown required [settings]="dropdownSettings" [placeholder]="'Seleziona'" name="sede"
                               [data]="tipologieSedi" [(ngModel)]="selectedSede.tipiObject">
      </ng-multiselect-dropdown>
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="indirizzo" class="control-label col-form-label">Indirizzo:</label>
      <input type="text" required [(ngModel)]="selectedSede.indirizzo" class="form-control" id="indirizzo" placeholder="indirizzo">
    </div>
  </div>
  <div class="row " style="padding-left: 10px; padding-right: 10px;">
    <div class="col-6">
      <div class="form-group">
        <label for="cap" class="control-label col-form-label">Cap:</label>
        <input type="text" required [(ngModel)]="selectedSede.cap" class="form-control" id="cap"
               placeholder="cap">
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="provincia" class="control-label col-form-label">Provincia:</label>
        <input type="text" required [(ngModel)]="selectedSede.provincia" class="form-control" id="provincia" placeholder="provincia">
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="citta" class="control-label col-form-label">Citta:</label>
      <input type="text" required [(ngModel)]="selectedSede.citta" class="form-control" id="citta"
             placeholder="citta">
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="email" class="control-label col-form-label">Email:</label>
      <input type="text" [(ngModel)]="selectedSede.email" class="form-control" id="email" placeholder="email">
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="telefono" class="control-label col-form-label">Telefono:</label>
      <input type="text" [(ngModel)]="selectedSede.telefono" class="form-control" id="telefono" placeholder="telefono">
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="fax" class="control-label col-form-label">Fax:</label>
      <input type="text" [(ngModel)]="selectedSede.fax" class="form-control" id="fax" placeholder="fax">
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="note" class="control-label col-form-label">Note:</label>
      <textarea type="text" [(ngModel)]="selectedSede.note" class="form-control" id="note" placeholder="note"></textarea>
    </div>
  </div>
  <div class="col-12" *ngIf="sedeType == 'Formazione' && selectedSede.id">
    <app-aule-list [(AuleSedi)]="selectedSede.aule" [(sede)]="selectedSede.id"></app-aule-list>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
